import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

export default function ProfilePage() {
  const [profile, setProfile] = useState({
    name: 'Ian Geerts', email: 'Bcgeerts@execulink.com', role: 'Owner / Operator',
    phone: '(306) 590-8539', company: 'Geerts Farms Ltd.', location: 'Kamsack, SK',
    sites: ['Kamsack Main', 'North Range'], totalAcres: '25,000',
    equipment: '6 NH tractors, 8 NH combines, 4 drills, 3 sprayers',
    season: '2025 Spring Seeding',
  });
  const [notifications, setNotifications] = useState({
    dailyReport: true, maintenanceAlerts: true, weatherAlerts: true,
    payrollReady: true, moveUpdates: false, weeklyDigest: true,
  });
  useEffect(function() { /* Future: fetch from supabase */ }, []);

  var inp = { width: '100%', padding: '0.6rem', background: 'var(--bg)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: '8px', boxSizing: 'border-box', fontSize: '0.95rem' };
  var label = { color: 'var(--text-secondary)', fontSize: '0.85rem', display: 'block', marginBottom: '4px' };

  return (
    <div className="page-container">
      <div className="page-header" style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0, color: 'var(--text)' }}>Profile Settings</h1>
        <p style={{ margin: '4px 0 0', color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Manage your account and preferences</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
        <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: '#fff', fontWeight: 700 }}>BG</div>
            <div>
              <h2 style={{ margin: 0, color: 'var(--text)' }}>{profile.name}</h2>
              <p style={{ margin: '2px 0 0', color: 'var(--primary)', fontSize: '0.9rem' }}>{profile.role}</p>
              <p style={{ margin: '2px 0 0', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>{profile.company} &mdash; {profile.location}</p>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div><label style={label}>Full Name</label><input type="text" value={profile.name} readOnly style={inp}/></div>
            <div><label style={label}>Email</label><input type="email" value={profile.email} readOnly style={inp}/></div>
            <div><label style={label}>Phone</label><input type="tel" value={profile.phone} readOnly style={inp}/></div>
            <div><label style={label}>Company</label><input type="text" value={profile.company} readOnly style={inp}/></div>
            <div><label style={label}>Location</label><input type="text" value={profile.location} readOnly style={inp}/></div>
            <div><label style={label}>Role</label><input type="text" value={profile.role} readOnly style={inp}/></div>
          </div>
          <button style={{ marginTop: '1rem', background: 'var(--primary)', color: '#fff', border: 'none', padding: '0.5rem 1.5rem', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>Save Changes</button>
        </div>

        <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
          <h3 style={{ color: 'var(--text)', marginTop: 0 }}>Operation Details</h3>
          <div style={{ marginBottom: '1rem' }}>
            {[{l:'Season',v:profile.season},{l:'Total Acres',v:profile.totalAcres},{l:'Sites',v:profile.sites.join(', ')},{l:'Equipment',v:profile.equipment},{l:'Location',v:profile.location}].map(function(item){
              return <div key={item.l} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.75rem 0', borderBottom: '1px solid var(--border)' }}><span style={{ color: 'var(--text-secondary)' }}>{item.l}</span><span style={{ color: 'var(--text)', fontWeight: 600, textAlign: 'right', maxWidth: '60%' }}>{item.v}</span></div>;
            })}
          </div>
          <h3 style={{ color: 'var(--text)', marginTop: '1.5rem' }}>Notifications</h3>
          {Object.keys(notifications).map(function(key){
            var lbl = key.replace(/([A-Z])/g, ' $1').replace(/^./, function(s){return s.toUpperCase();});
            return (
              <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.6rem 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ color: 'var(--text)' }}>{lbl}</span>
                <div onClick={function(){var n=Object.assign({},notifications); n[key]=!n[key]; setNotifications(n);}} style={{ width: '44px', height: '24px', borderRadius: '12px', background: notifications[key] ? 'var(--primary)' : 'var(--border)', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}>
                  <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '2px', left: notifications[key] ? '22px' : '2px', transition: 'left 0.2s' }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
